var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7H7C5.34315 7 4 8.34315 4 10V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V10C20 8.34315 18.6569 7 17 7H15.75M8.25 7H15.75M8.25 7V5.75048C8.25 3.67941 9.92893 2 12 2C14.0711 2 15.75 3.67941 15.75 5.75048V7M14 13.7676C14 14.5078 13.5978 15.1542 13 15.5V16.7676C13 17.3198 12.5523 17.7676 12 17.7676C11.4477 17.7676 11 17.3198 11 16.7676V15.5C10.4022 15.1542 10 14.5078 10 13.7676C10 12.663 10.8954 11.7676 12 11.7676C13.1046 11.7676 14 12.663 14 13.7676Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c1a8deeac028f2cc253b134be09e921d.svg";
export { ForwardRef as ReactComponent };